import { NgModule } from '@angular/core';
import { NgCanDirective, NgCanNotDirective } from './ng-can.directive';

/**
 * Modulo dedicato alle direttive strutturali sui permessi (*ngCan / *ngCanNot).
 * Isolato in un modulo leggero cosi' da poter essere importato sia da SharedModule
 * sia da CoreModule senza trascinare l'intero SharedModule.
 */
@NgModule({
  declarations: [NgCanDirective, NgCanNotDirective],
  exports: [NgCanDirective, NgCanNotDirective],
})
export class NgCanModule {
}
